import React from 'react';
import './App.css';

import { Container } from 'src/components';

function App() {
  return (
    <div className="container">
      <Container />
    </div>
  );
}

export default App;
